import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Close } from '@mui/icons-material';
import PostComments from 'components/play/PostComments';

/**
 * OTRIX Play — "ver todos los comentarios" de una rutina. El hilo completo (like / responder /
 * borrar propios) vive en PostComments; este diálogo sólo lo enmarca. Los comentarios inline del
 * feed usan el mismo componente en modo preview.
 */
function RoutineCommentsDialog({ open, routine = null, onClose, onOpenAuthor = null }) {
  const { t } = useTranslation(['play']);
  const theme = useTheme();
  // A pantalla completa en mobile: un hilo de comentarios dentro de un diálogo pequeño a 320
  // deja el texto sin ancho (mismo criterio que el detalle de Rendimientos).
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={fullScreen}
      maxWidth="sm"
      PaperProps={{
        sx: {
          backgroundColor: 'surface.content',
          backgroundImage: 'none',
          ...(fullScreen ? {} : { borderRadius: 3, border: '1px solid', borderColor: 'hairline.main' })
        }
      }}>
      <DialogTitle sx={{ pb: 1, pr: 5 }}>
        <Typography variant="h6" fontWeight={800}>
          {routine?.name}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t('forum.commentsTitle', { ns: 'play', defaultValue: 'Comentarios de la comunidad' })}
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>{open && routine && <PostComments routineId={routine.id} onOpenAuthor={onOpenAuthor} />}</DialogContent>
    </Dialog>
  );
}

RoutineCommentsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  routine: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onOpenAuthor: PropTypes.func
};

export default RoutineCommentsDialog;
